import { Controller } from "@hotwired/stimulus";
import { useOutlets } from "hb/insights/use_outlets";

export default class extends Controller {
  static targets = ["errorItem", "searchIndicator", "summaryStats"];

  connect() {
    useOutlets(this);
  }

  shouldReload(widget) {
    return widget.query.includes("@ts");
  }
}
